import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Input } from "components"
import InventoryRowCheckbox from "./InventoryRowCheckbox"
import InventoryRowApplyButton from "./InventoryRowApplyButton"
import InventoryRowSwitch from "./InventoryRowSwitch"
import classes from "./InventoryTableSimpleRow.module.scss"

const InventoryTableRow = props => {
  const { food } = props

  const [t, i18n] = useTranslation()

  const option = food.options[0]

  const initialAvailableQuantityState =
    option.availableQuantity

  const inititalOutOfStockState =
    option.outOfStock

  const inititalStockManagementState =
    option.stockManagement

  const [loading, setLoading] = useState(false)
  const [sending, setSending] = useState(false)
  const [stockIn, setStockIn] = useState("")
  const [stockOut, setStockOut] = useState("")
  const [outOfStock, setOutOfStock] = useState(inititalOutOfStockState)
  const [stockManagement, setStockManagement] = useState(inititalStockManagementState)
  const [availableQuantity, setAvailableQuantity] = useState(initialAvailableQuantityState)

  const disabled = !stockManagement

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <tr className={classes["container"]}>
      <td className={clsx(classes.cell, classes.code)}>
        {food.code}
      </td>
      <td className={clsx(classes.cell, classes.name)}>
        {food.name}
      </td>
      <td className={clsx(classes["cell"])}>
        <div className={classes["stock-management"]}>
          <InventoryRowCheckbox
            food={food}
            option={option}
            stockManagement={stockManagement}
            setStockManagement={setStockManagement}
            availableQuantity={availableQuantity}
            setOutOfStock={setOutOfStock}
          />

          <Input
            min={0}
            type="number"
            disabled={disabled}
            className={clsx(
              classes["input"],
              isLtr && classes["input-ltr"],
              disabled && classes["disabled"]
            )}
            placeholder={t("ورودی")}
            numberType={food.unit === "quantity" ? "int" : "float"}
            value={stockIn}
            onChange={(e) => {
              setStockOut("")
              setStockIn(e.target.value)
            }}
          />

          <Input
            min={0}
            type="number"
            disabled={disabled}
            placeholder={t("خروجی")}
            className={clsx(
              classes["input"],
              isLtr && classes["input-ltr"],
              disabled && classes["disabled"]
            )}
            numberType={food.unit === "quantity" ? "int" : "float"}
            value={stockOut}
            onChange={(e) => {
              setStockIn("")
              setStockOut(e.target.value)
            }}
          />

          <InventoryRowApplyButton
            food={food}
            option={option}
            sending={sending}
            setSending={setSending}
            setOutOfStock={setOutOfStock}
            stockIn={stockIn}
            setStockIn={setStockIn}
            stockOut={stockOut}
            setStockOut={setStockOut}
            stockManagement={stockManagement}
            availableQuantity={availableQuantity}
            setAvailableQuantity={setAvailableQuantity}
          />
        </div>
      </td>
      <td className={clsx(classes["cell"], classes["outOfStock"])}>
        <InventoryRowSwitch
          food={food}
          option={option}
          loading={loading}
          setStockIn={setStockIn}
          setStockOut={setStockOut}
          setLoading={setLoading}
          outOfStock={outOfStock}
          setOutOfStock={setOutOfStock}
          setAvailableQuantity={setAvailableQuantity}
        />
      </td>
      <td className={clsx(classes.cell, classes.inventory)}>
        {stockManagement ? availableQuantity : "-"}
      </td>
    </tr>
  )
}

export default React.memo(InventoryTableRow)